/**
 * ballTheme — the classic bingo ball look, identical for every number.
 *
 * Premium red-and-white cinematic sphere: deep crimson outer with a
 * highlight sheen, a bright white face where the number reveals.
 * The visual excitement comes from the spin, the open, the magic trail,
 * and the board highlight — not from color-coded balls.
 */

const CLASSIC_BALL = {
  // Rich cinematic red used across the sphere.
  core: "#D62828",
  highlight: "#FCA5A5",
  shadow: "#7F1D1D",
  glow: "rgba(214, 40, 40, 0.55)",
};

/**
 * getBallTheme()
 * Returns the same classic red-and-white theme for every number.
 */
export function getBallTheme() {
  return CLASSIC_BALL;
}
